<script setup>
  // @ts-check
  import { computed } from 'vue';
  import { RouterView, useRoute } from 'vue-router';
  import TheNavigationBar from '@/layout/TheNavigationBar.vue';
  import DebugInfo from '@/components/debug/DebugInfo.vue';
  import { EtLoader } from 'vue-ui-kit';
  import { useAuth } from '@common/composables/auth/authPlugin.js';
  import { useUserStore } from '@common/store/index.js';

  const route = useRoute();
  const auth = useAuth();
  const userStore = useUserStore();

  const isAuth = computed(() => auth.isAuthenticated.value);
  const isReady = computed(() => route.name != null && userStore.isReady && !isAuth.value);
</script>
  <!-- <KindeError v-if="kinde.hasError.value" /> -->

<template>
  <TheNavigationBar v-if="isReady" />
  <RouterView v-if="isReady" />
  <DebugInfo v-if="auth.isAuthenticated && userStore.isETAdmin" />
  <EtLoader
    :loading="!isReady"
    is-page />
</template>
